const servicesData = [
  {
    title: "General Dentistry",
    titleTe: "సాధారణ దంత వైద్యం",
    description: "Routine checkups, fillings, and preventive care.",
    descTe: "క్రమమైన దంత పరీక్షలు, ఫిల్లింగ్స్ మరియు దంత సంరక్షణ.",
    bgColor: "bg-blue-200",
    image: "/dentistry.jpg",
    link: "/services/general-dentistry",
  },
  {
    title: "Cosmetic Dentistry",
    titleTe: "కాస్మెటిక్ డెంటిస్ట్రీ",
    description: "Whitening, veneers, and smile enhancements.",
    descTe: "దంతాల మెరుపు, వెనీర్స్ మరియు అందమైన నవ్వు దిద్దుబాట్లు.",
    bgColor: "bg-green-200",
    image: "/cosmetic.jpg",
    link: "/services/cosmetic-dentistry",
  },
  {
    title: "Orthodontics",
    titleTe: "ఆర్థోడాంటిక్స్ (క్లిప్‌లు)",
    description: "Braces, clear aligners, and teeth alignment.",
    descTe: "బ్రేసెస్, అలై నర్స్ మరియు వంకర దంతాల సరిచేత.",
    bgColor: "bg-yellow-200",
    image: "/orthodontics.jpg",
    link: "/services/orthodontics",
  },
  {
    title: "Teeth Whitening",
    titleTe: "దంతాల మెరుపు (వైటనింగ్)",
    description: "Professional whitening treatments for a bright smile.",
    descTe: "దంతాల పసుపుతనం తొలగించి తెల్లగా మెరిసేలా చేయడం.",
    bgColor: "bg-pink-200",
    image: "/teethwhitening.jpg",
    link: "/services/teeth-whitening",
  },
  {
    title: "Root Canal Treatment",
    titleTe: "రూట్ కెనాల్ చికిత్స",
    description: "Save your tooth with painless expert care.",
    descTe: "నొప్పుల్లేని రూట్ కెనాల్ ద్వారా మీ దంతాన్ని కాపాడుకోండి.",
    bgColor: "bg-indigo-200",
    image: "/rootcanal.jpg",
    link: "/services/root-canal-treatment",
  },
  {
    title: "Crowns and Bridges",
    titleTe: "క్యాప్‌లు & బ్రిడ్జిలు",
    description: "Restore your smile with durable solutions.",
    descTe: "పడిపోయిన దంతాల స్థానంలో బలమైన క్యాప్‌లు మరియు బ్రిడ్జిలు.",
    bgColor: "bg-purple-200",
    image: "/crowns.jpg",
    link: "/services/crowns-bridges",
  },
  {
    title: "Braces and Aligners",
    titleTe: "బ్రేసెస్ & అలై నర్స్",
    description: "Straighten your teeth with comfort and precision.",
    descTe: "వంకర దంతాలను చక్కని వరుసలో అమర్చడం.",
    bgColor: "bg-red-200",
    image: "/braces.jpg",
    link: "/services/braces-aligners",
  },
  {
    title: "Wisdom Teeth Removal",
    titleTe: "జ్ఞాన దంతాల తొలగింపు",
    description: "Safe extractions of wisdom teeth by MDS surgeons.",
    descTe: "నొప్పి కలిగించే జ్ఞాన దంతాలను సురక్షితంగా తొలగించడం.",
    bgColor: "bg-teal-200",
    image: "/wisdomteeth.jpg",
    link: "/services/wisdom-teeth-removal",
  },
  {
    title: "Dentures",
    titleTe: "కట్టుడు పళ్ళు (డెంచర్స్)",
    description: "Custom dentures for a comfortable natural fit.",
    descTe: "సహజమైన రూపుతో కూడిన సౌకర్యవంతమైన కట్టుడు పళ్ళు.",
    bgColor: "bg-orange-200",
    image: "/dentures.jpg",
    link: "/services/dentures",
  },
  {
    title: "Dental Implants",
    titleTe: "డెంటల్ ఇంప్లాంట్లు",
    description: "Permanent tooth replacement solutions.",
    descTe: "శాశ్వతమైన దంతాల అమరిక (డెంటల్ ఇంప్లాంట్లు).",
    bgColor: "bg-gray-200",
    image: "/implants.jpg",
    link: "/services/implants",
  },
  {
    title: "Laser Dentistry",
    titleTe: "లేజర్ డెంటిస్ట్రీ",
    description: "State-of-the-art laser treatments for precise care.",
    descTe: "అత్యాధునిక లేజర్ పరిజ్ఞానంతో ఖచ్చితమైన చికిత్సలు.",
    bgColor: "bg-blue-300",
    image: "/laser.jpg",
    link: "/services/laser-dentistry",
  },
  {
    title: "Flap Surgeries",
    titleTe: "చిగుళ్ళ శస్త్రచికిత్స (ఫ్లాప్)",
    description: "Advanced surgical procedures for gum health.",
    descTe: "చిగుళ్ళ సమస్యలు మరియు జిగురు వాపుల నివారణ శస్త్రచికిత్స.",
    bgColor: "bg-green-300",
    image: "/flap.jpg",
    link: "/services/flap-surgeries",
  },
  {
    title: "Facial Bone Fractures",
    titleTe: "ముఖ ఎముకల ఫ్రాక్చర్లు",
    description: "Expert care for fractures in the facial bones.",
    descTe: "ముఖం మరియు దవడ ఎముకల గాయాలకు ప్రత్యేక చికిత్స.",
    bgColor: "bg-yellow-300",
    image: "/facial.jpg",
    link: "/services/facial-bone-fractures",
  },
  {
    title: "Kids Braces",
    titleTe: "పిల్లల బ్రేసెస్",
    description: "Braces tailored for children's dental growth.",
    descTe: "పిల్లల దంత పెరుగుదలకు తగిన బ్రేసెస్ అమరిక.",
    bgColor: "bg-pink-300",
    image: "/kids.jpg",
    link: "/services/kids-braces",
  },
  {
    title: "Child Dental Care",
    titleTe: "పిల్లల దంత వైద్యం",
    description: "Gentle and comprehensive care for young smiles.",
    descTe: "చిన్నారులకు అనుకూలమైన, సున్నితమైన దంత సంరక్షణ.",
    bgColor: "bg-indigo-300",
    image: "/child.jpg",
    link: "/services/child-dental-care",
  },
  {
    title: "TMJ Pain Treatment",
    titleTe: "దవడ నొప్పి చికిత్స (TMJ)",
    description: "Effective treatments for jaw pain and dysfunction.",
    descTe: "దవడ నొప్పులు మరియు నమిలేటప్పుడు వచ్చే సమస్యల పరిష్కారం.",
    bgColor: "bg-purple-300",
    image: "/tmjpain.jpg",
    link: "/services/tmj-pain",
  },
  {
    title: "Cysts & Tumours of Jaws",
    titleTe: "దవడ గడ్డల చికిత్స",
    description: "Diagnosis and treatment of jaw cysts and tumors.",
    descTe: "దవడల్లో వచ్చే గడ్డలు మరియు తిత్తుల శస్త్రచికిత్స.",
    bgColor: "bg-red-300",
    image: "/facial.jpg",
    link: "/services/cysts-tumours-jaws",
  },
  {
    title: "Oral Cancer Screening",
    titleTe: "నోటి క్యాన్సర్ పరీక్షలు",
    description: "Screening and treatment for oral cancer.",
    descTe: "నోటి క్యాన్సర్ ముందస్తు నిర్ధారణ మరియు చికిత్సలు.",
    bgColor: "bg-teal-300",
    image: "/oral.jpg",
    link: "/services/oral-cancer",
  },
  {
    title: "Jaw Abnormalities",
    titleTe: "దవడ ఆకార సమస్యలు",
    description: "Diagnosis and treatment of jaw alignment issues.",
    descTe: "దవడ నిర్మాణంలో వచ్చే లోపాల శస్త్రచికిత్స దిద్దుబాట్లు.",
    bgColor: "bg-orange-300",
    image: "/jaw.jpg",
    link: "/services/jaw-abnormalities",
  },
];

export default servicesData;
